import React, { useState, useEffect } from 'react';
import DefaultLayout from 'components/DefaultLayout';
import font from 'assets/fonts/gilroy/Gilroy-Regular.ttf';
import font2 from 'assets/fonts/gilroy/Gilroy-Bold.ttf';
import font3 from 'assets/fonts/gilroy/Gilroy-Semibold.ttf';
import font4 from 'assets/fonts/gilroy/Gilroy-Extrabold.ttf';
import moment from 'moment';
import { Page, Text, View, Document, StyleSheet, Image, PDFViewer , Font } from "@react-pdf/renderer";
import { Svg, G, Polygon, Path } from "@react-pdf/primitives";
import { useIntl } from 'react-intl';
import config from 'config/config'
import coursesApiClient from 'utils/coursesApiClient';

Font.register({ family: 'Gilroy', fonts: [
  { src: font,  fontWeight: 'normal' ,format: "truetype"},
  { src: font3, fontWeight: 'semibold' ,format: "truetype"}
]});
Font.register({ family: 'Gilroy-Extrabold', src: font4, fontWeight: 'ultrabold' ,format: "truetype"});
Font.register({ family: 'Gilroy-Bold', src: font2, fontWeight: 'bold' ,format: "truetype"});



const CamapaignCertificate: React.FC<any> = (props) => {
  const [propValues, setPropValues ] = useState();
  const [data, setData] =  useState<any>([]);
  const [dataLoading, setDataLoading] = useState(true);
  const [logo, setLogo] = useState<any>();

  const intl = useIntl();

  if (props.data !== propValues){
    setPropValues(props.data);
  }

  useEffect(() => {
    
    const loadData = async () => {
      setDataLoading(true)
      setData({
        titleId: props.data.certificateName ? props.data.certificateName : props.data.name,
        textAfter: props.data.textAfter,
        textBefore: props.data.textBefore,
        issued: moment().format("DD/MM/YYYY"),
        validUntilDate: moment().add(props.data.validUntil, 'days').format("DD/MM/YYYY"),
        name: 'John',
        surname: 'Smith'
      })
      setTimeout(() => {
        setDataLoading(false);
      }, 100);
    };

    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [propValues]);

const styles = StyleSheet.create({
  pageBackground: {
    position: 'absolute',
    height: 600,
    width: 860,
  },
  title: {
    fontSize: '60', 
    fontWeight: 'bold', 
    marginTop: '44',
    textAlign: 'center',
    fontFamily: 'Gilroy',
  },
  textBefore: {
    fontSize: '18', 
    fontWeight: 'semibold',
    marginTop: '29px',
    marginLeft: '105px',
    marginRight: '105px',
    maxWidth: '75%',
    textAlign: 'center',
    fontFamily: 'Gilroy',
    textTransform: 'uppercase',
    letterSpacing: 4,
    fontVariantCaps: 'small-caps'
  },
  name: {
    fontSize: '54', 
    fontWeight: 'bold', 
    marginTop: '34',
    textAlign: 'center',
    letterSpacing: '-1.08px',
    fontFamily: 'Gilroy',
  },
  textAfter: {
    fontSize: '22', 
    fontWeight: 'thin', 
    marginTop: '39',
    textAlign: 'center',
    fontFamily: 'Gilroy'
  },
  issuedCertificate: {
    color: 'red', 
    fontSize: '10', 
    marginTop: '97',
    textAlign: 'right',
    fontFamily: 'Gilroy',
    paddingRight: '40',
    width: '50%',
  },
  validUntil: {
    color: 'red', 
    fontSize: '10', 
    marginTop: '97',
    textAlign: 'left',
    fontFamily: 'Gilroy',
    paddingLeft: '40',
    width: '50%',
  },
  image: {
    width:'100%',
    maxWidth: 160,
    height: 48,
    margin:'auto'
  },
  onlyIssued: {
    color: 'red', 
    fontSize: '10', 
    marginTop: '97',
    textAlign: 'center',
    fontFamily: 'Gilroy',
    width: '100%',
  },
});

useEffect(() => {
  if (config.api.appAppearance.logoPath) {
    loadLogo();
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
}, []);

  const loadLogo = async () => {
    try {

      const response = await coursesApiClient.request(`api/v1${config.api.appAppearance.logoPath}`, {}, 'GET', true, true, {}, 'arraybuffer');

        let base64 = btoa(
            new Uint8Array(response)
                .reduce((data, byte) => data + String.fromCharCode(byte), '')
        );

      setLogo('data:image/png;base64,' + base64);
    } catch (error) {
    } finally {
    }
  };


const MyDoc = () => {
  return (
    <Document>
      {
        !dataLoading && props.showPreviewModel ? 
          <Page orientation={'landscape'}>
            <View style={config.api.appAppearance.logoPath ? {paddingTop:20} : {}}>
              <Image src={props.previewLink} style={styles.pageBackground}/>
              {config.api.appAppearance.logoPath ? 
                <Image style={styles.image} src={logo}/>
                :
                <View style={{display: 'flex', justifyContent: 'center'}}>
                <Svg style={{marginTop: '71', width: '100%'}} width="156px" height="26px" viewBox="0 0 241 40" version="1.1" xmlns="http://www.w3.org/2000/svg">
                  <G id="Log-in" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <G transform="translate(-520.000000, -287.000000)" fill-rule="nonzero" id="logo">
                      <G transform="translate(520.000000, 287.000000)">
                        <Path d="M82.5051775,29.1555496 C84.5170118,29.1555496 86.3716716,28.6880755 88.0377219,27.7531273 C89.7352071,26.7870142 91.0554734,25.5092517 91.9670858,23.9198398 L88.8235947,22.1434383 C87.6919379,24.2938191 85.2714497,25.6650764 82.5051775,25.6650764 C80.1475592,25.6650764 78.2614645,24.9171179 76.7840237,23.4523658 C75.3380178,21.9876136 74.6150148,20.1177173 74.6150148,17.8426768 C74.6150148,15.5676362 75.3380178,13.6977399 76.7840237,12.2329878 C78.2614645,10.7682356 80.1475592,10.0202771 82.5051775,10.0202771 C85.2714497,10.0202771 87.660503,11.3915344 88.8235947,13.5419152 L91.9670858,11.7343488 C90.0809911,8.52436005 86.4974112,6.52980396 82.5051775,6.52980396 C79.2045118,6.52980396 76.4382396,7.62057682 74.2692308,9.80212254 C72.1002219,11.9525033 71,14.6326881 71,17.8426768 C71,21.0526655 72.1002219,23.7328502 74.2692308,25.9143959 C76.4382396,28.0647767 79.2045118,29.1555496 82.5051775,29.1555496 Z M98.285503,28.7504054 L98.285503,6 L94.8905325,6 L94.8905325,28.7504054 L98.285503,28.7504054 Z M109.633506,29.1555496 C111.959689,29.1555496 113.908654,28.3764261 115.511834,26.7870142 C117.115015,25.1976023 117.932322,23.2653761 117.932322,20.9591707 C117.932322,18.6529652 117.115015,16.720739 115.511834,15.1313271 C113.908654,13.5419152 111.959689,12.7627917 109.633506,12.7627917 C107.338757,12.7627917 105.358358,13.5419152 103.755178,15.1313271 C102.151997,16.720739 101.334689,18.6529652 101.334689,20.9591707 C101.334689,23.2653761 102.151997,25.1976023 103.755178,26.7870142 C105.358358,28.3764261 107.338757,29.1555496 109.633506,29.1555496 Z M109.633506,25.883231 C108.25037,25.883231 107.087278,25.4157569 106.144231,24.4808087 C105.201183,23.5458606 104.72966,22.3615929 104.72966,20.9591707 C104.72966,19.5567484 105.201183,18.3724807 106.144231,17.4375326 C107.087278,16.5025844 108.25037,16.0351103 109.633506,16.0351103 C111.016642,16.0351103 112.179734,16.5025844 113.122781,17.4375326 C114.065828,18.3724807 114.537352,19.5567484 114.537352,20.9591707 C114.537352,22.3615929 114.065828,23.5458606 113.122781,24.4808087 C112.179734,25.4157569 111.016642,25.883231 109.633506,25.883231 Z M126.734098,29.1555496 C128.965976,29.1555496 130.569157,28.3452612 131.606509,26.7558493 L131.606509,28.7504054 L135.001479,28.7504054 L135.001479,13.1679359 L131.606509,13.1679359 L131.606509,21.5201396 C131.606509,24.5431386 130.003328,26.0078907 127.614275,26.0078907 C125.445266,26.0078907 124.093565,24.7301283 124.093565,22.3927578 L124.093565,13.1679359 L120.698595,13.1679359 L120.698595,22.7355722 C120.698595,26.7246843 123.119083,29.1555496 126.734098,29.1555496 Z M145.909393,29.1555496 C148.298447,29.1555496 150.121672,28.2829313 151.410503,26.5065298 L151.410503,28.7504054 L154.805473,28.7504054 L154.805473,6.93494817 L151.410503,6.93494817 L151.410503,15.3806466 C150.121672,13.63541 148.298447,12.7627917 145.909393,12.7627917 C143.740385,12.7627917 141.91716,13.5419152 140.376849,15.1313271 C138.836538,16.720739 138.082101,18.6529652 138.082101,20.9591707 C138.082101,23.2342112 138.836538,25.1976023 140.376849,26.7870142 C141.91716,28.3764261 143.740385,29.1555496 145.909393,29.1555496 Z M146.443787,25.9455609 C145.029216,25.9455609 143.834689,25.4780868 142.891642,24.5431386 C141.948595,23.5770255 141.477071,22.3927578 141.477071,20.9591707 C141.477071,19.5255835 141.948595,18.3413158 142.891642,17.4063676 C143.834689,16.4402545 145.029216,15.9727804 146.443787,15.9727804 C147.858358,15.9727804 149.052885,16.4402545 149.995932,17.4063676 C150.938979,18.3413158 151.410503,19.5255835 151.410503,20.9591707 C151.410503,22.3927578 150.938979,23.5770255 149.995932,24.5431386 C149.052885,25.4780868 147.858358,25.9455609 146.443787,25.9455609 Z M166.310651,29.1555496 C168.636834,29.1555496 170.522929,28.5945807 171.9375,27.4414779 C173.383506,26.2883752 174.106509,24.6989633 174.106509,22.7355722 C174.263683,20.6475213 173.006287,19.1516042 171.843195,18.247821 C171.497411,17.9673365 170.963018,17.6556871 170.240015,17.3752027 C169.548447,17.0947182 169.014053,16.8765637 168.605399,16.7519039 C168.22818,16.5960792 167.630917,16.4090896 166.782175,16.1286051 C163.418639,15.1001621 162.349852,14.3522036 162.349852,12.7316268 C162.349852,11.079885 163.701553,10.0202771 165.807692,10.0202771 C167.976701,10.0202771 169.517012,11.0487201 170.428624,13.0744411 L173.477811,11.3292045 C172.06324,8.33737041 169.328402,6.52980396 165.807692,6.52980396 C163.858728,6.52980396 162.192678,7.09077286 160.809541,8.2438756 C159.426405,9.3658134 158.734837,10.8928954 158.734837,12.8251216 C158.734837,14.7885128 159.45784,16.2220999 160.872411,17.219378 C162.349852,18.1854911 163.387204,18.5906353 165.493343,19.2139341 C167.348003,19.774903 168.668269,20.3047069 169.391272,20.772181 C170.114275,21.2396551 170.491494,21.8941188 170.491494,22.797902 C170.491494,24.5119737 169.139793,25.6650764 166.404956,25.6650764 C163.638683,25.6650764 161.815459,24.4496438 160.935281,21.9876136 L157.823225,23.7951801 C158.986317,27.1298285 162.066938,29.1555496 166.310651,29.1555496 Z M185.800296,28.7504054 L185.800296,25.7274063 C183.222633,25.8520661 181.902367,25.883231 181.902367,23.8886749 L181.902367,16.4090896 L185.800296,16.4090896 L185.800296,13.1679359 L181.902367,13.1679359 L181.902367,8.8048445 L178.507396,9.80212254 L178.507396,13.1679359 L175.615385,13.1679359 L175.615385,16.4090896 L178.507396,16.4090896 L178.507396,23.8886749 C178.507396,27.9712819 180.613536,29.3737041 185.800296,28.7504054 Z M194.759246,29.1555496 C196.991124,29.1555496 198.594305,28.3452612 199.631657,26.7558493 L199.631657,28.7504054 L203.026627,28.7504054 L203.026627,13.1679359 L199.631657,13.1679359 L199.631657,21.5201396 C199.631657,24.5431386 198.028476,26.0078907 195.639423,26.0078907 C193.470414,26.0078907 192.118713,24.7301283 192.118713,22.3927578 L192.118713,13.1679359 L188.723743,13.1679359 L188.723743,22.7355722 C188.723743,26.7246843 191.144231,29.1555496 194.759246,29.1555496 Z M213.934541,29.1555496 C216.323595,29.1555496 218.14682,28.2829313 219.435651,26.5065298 L219.435651,28.7504054 L222.830621,28.7504054 L222.830621,6.93494817 L219.435651,6.93494817 L219.435651,15.3806466 C218.14682,13.63541 216.323595,12.7627917 213.934541,12.7627917 C211.765533,12.7627917 209.942308,13.5419152 208.401997,15.1313271 C206.861686,16.720739 206.107249,18.6529652 206.107249,20.9591707 C206.107249,23.2342112 206.861686,25.1976023 208.401997,26.7870142 C209.942308,28.3764261 211.765533,29.1555496 213.934541,29.1555496 Z M214.468935,25.9455609 C213.054364,25.9455609 211.859837,25.4780868 210.91679,24.5431386 C209.973743,23.5770255 209.502219,22.3927578 209.502219,20.9591707 C209.502219,19.5255835 209.973743,18.3413158 210.91679,17.4063676 C211.859837,16.4402545 213.054364,15.9727804 214.468935,15.9727804 C215.883506,15.9727804 217.078033,16.4402545 218.02108,17.4063676 C218.964127,18.3413158 219.435651,19.5255835 219.435651,20.9591707 C219.435651,22.3927578 218.964127,23.5770255 218.02108,24.5431386 C217.078033,25.4780868 215.883506,25.9455609 214.468935,25.9455609 Z M234.964497,29.2490444 L241,13.1679359 L237.384985,13.1679359 L233.361317,24.4808087 L228.677515,13.1679359 L224.968195,13.1679359 L231.632396,28.4699209 L231.475222,28.7815703 C230.626479,30.9319511 229.431953,31.9603941 227.294379,31.8357343 L227.294379,34.9833931 C230.909393,35.2015477 233.455621,33.2693215 234.964497,29.2490444 Z" id="CloudStudy" fill="#1F192F"></Path>
                        <Path d="M7.27659574,32 L7.29076363,31.9710932 C7.0864432,31.9902225 6.87945311,32 6.67021277,32 C2.98635598,32 3.55271368e-15,28.9693122 3.55271368e-15,25.2307692 C3.55271368e-15,21.5782562 2.85049571,18.6013952 6.41703442,18.4663247 C6.18716447,17.685007 6.06382979,16.8571205 6.06382979,16 C6.06382979,11.2418545 9.86464649,7.38461538 14.5531915,7.38461538 C15.7201438,7.38461538 16.8321029,7.62356516 17.8441528,8.05588219 C20.5611783,3.24290087 25.6733762,0 31.5319149,0 C38.5471729,0 44.4922779,4.64988661 46.5379252,11.0783547 L46.6914894,11.0769231 C52.3847226,11.0769231 57,15.7607134 57,21.5384615 C57,27.3162097 52.3847226,32 46.6914894,32 C46.4879181,32 46.285725,31.9940116 46.0850718,31.9821988 L46.0851064,32 L7.27659574,32 Z" id="Combined-Shape" fill="#D9DFFF"></Path>
                        <Polygon id="Rectangle" fill="#00A8CE" points="14 26 22 26 22 40 18 36.5777778 14 40"></Polygon>
                      </G>
                    </G>
                  </G>
                </Svg>
              </View>
              } 
              <Text style={styles.title}>{data.titleId}</Text>
              <Text style={styles.textBefore}>{data.textBefore}</Text>
              <Text style={styles.name}>{data.name + ' ' + data.surname}</Text>
              <Text style={styles.textAfter}>{data.textAfter}</Text>
              <View style={{flex: 1, flexDirection: 'row', flexWrap: 'wrap'}}>
                <Text style={data.validUntilDate !== data.issued ? styles.issuedCertificate : styles.onlyIssued}>{intl.formatMessage({id: 'campaign.issued_certificate'})}{data.issued}</Text>
                {
                  data.validUntilDate !== data.issued ? 
                  <Text style={styles.validUntil}>{intl.formatMessage({id: 'campaign.valid_until_certificicate'})}{data.validUntilDate}</Text>
                  : null
                }
              </View>
            </View>
          </Page>
      : null
      }
      
    </Document>
  )
}

return (
  <div>
    {
    !dataLoading && props.showPreviewModel ? 
      <DefaultLayout.PageLayout>
        <PDFViewer width={840} height={660} style={{border: 'none'}}>
          <MyDoc/>
        </PDFViewer >
      </DefaultLayout.PageLayout> 
    :null
    }
  </div>
)
}

export default CamapaignCertificate;